// src/app/AccountNew/Team/validationSchemas.js

import * as Yup from "yup";
import { isValidEmail, isValidPhone } from 'utils/validation';

export const chooseTierDefaultValue = {type: ""}
export const chooseCreateTeamDefaultValue = {firstName: "" ,lastName: "",phone:"",username:"",confirmEmail:"",newPwd:"",confirmPassword: "",spendingLimit:"0",propertyLimit:"0",profilePicture:[],securityDomainId:"1"}
export const step1ValidationSchema = Yup.object().shape({
  type: Yup.string().required('You must select a tier before continuing.')
});

export const profileValidationSchema = Yup.object().shape({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  phone: Yup.string().required("Phone Number is required.") // Check empty
  .test(
    "is-valid-phone",
    "Phone Number must be exactly 10 digits.",
    (value) => {
      if (!value) return true; // Skip test if empty
      const digitsOnly = value.replace(/\D/g, "");
      return digitsOnly.length === 10;
    }
  ),
  username: Yup.string()
    .required("Email is required.")
    .max(254, "Email must be at most 254 characters.")
    .email("Email is invalid."),

  confirmEmail: Yup.string()
    .required("Confirm Email is required.")
    .max(254, "Email must be at most 254 characters.")
    .email("Confirm Email is invalid.")
    .oneOf([Yup.ref("username")], "Emails must match"),
  newPwd: Yup.string()
  .min(8, "Password must be at least 8 characters")
  .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
  .matches(/[a-z]/, "Password must contain at least one lowercase letter")
  .matches(/[0-9]/, "Password must contain at least one number")
  .matches(/[@$!%*?&#]/, "Password must contain at least one special character")
  .required("Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPwd"), null], "Passwords must match")
    .required("Please confirm your password"),
    spendingLimit: Yup.string(),
    propertyLimit: Yup.string()
});

export const editProfileValidationSchema = Yup.object().shape({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  phone: Yup.string().required("Phone Number is required.") // Check empty
  .test(
    "is-valid-phone",
    "Phone Number must be exactly 10 digits.",
    (value) => {
      if (!value) return true; // Skip test if empty
      const digitsOnly = value.replace(/\D/g, "");
      return digitsOnly.length === 10;
    }
  ),
  username: Yup.string()
    .max(254, "Email must be at most 254 characters.")
    .email("Email is invalid."),
    confirmEmail: Yup.string()
    .max(254, "Email must be at most 254 characters.")
    .email("Confirm Email is invalid.")
    .when("username", (username, schema) => {
      return schema.oneOf([Yup.ref("username")], "Emails must match");
    }),
    newPwd: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
    .matches(/[a-z]/, "Password must contain at least one lowercase letter")
    .matches(/[0-9]/, "Password must contain at least one number")
    .matches(/[@$!%*?&#]/, "Password must contain at least one special character")
    .oneOf([Yup.ref("confirmPassword")], "Passwords must match"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPwd"), null], "Passwords must match"),
    spendingLimit: Yup.number(),
    propertyLimit: Yup.number(),
    // profilePicture: []
});


export const reviewTeamValidationSchema = Yup.object().shape({
  agreeToTerms: Yup.boolean().default(false).required("You must agree to the terms"),
});


export const getFullDataURL = (base64String) => {
  const binaryString = atob(base64String);
  const bytes = Array.from(binaryString).map(c => c.charCodeAt(0));

  // Extract first 12 bytes for comprehensive format matching
  const hexBytes = bytes
      .slice(0, 12)
      .map(b => b.toString(16).padStart(2, "0"))
      .join(" ");

  let mimeType = "";

  // PNG
  if (hexBytes.startsWith("89 50 4e 47")) {
      mimeType = "image/png";

  // JPEG
  } else if (hexBytes.startsWith("ff d8 ff")) {
      mimeType = "image/jpeg";

  } else if (
      binaryString.startsWith("RIFF") &&
      binaryString.slice(8, 12) === "WEBP"
  ) {
      mimeType = "image/webp";

  // HEIF/HEIC (brand `heic` or `heif` in ftyp box at offset 8)
  } else if (binaryString.trimStart().startsWith("<svg")) {
      mimeType = "image/svg+xml";

  } else {
      throw new Error("Unknown or unsupported image format");
  }

  return `data:${mimeType};base64,${base64String}`;
};